import { Client, ClientBuilder, type ClientRequest, ProcessFn, ProcessOptions } from "@commercetools/sdk-client-v2"

const projectKey = "ctp"

const scopes = ["manage_project:jogg-workshop-team-29,manage_project:jogg-workshop-team-30"]

// Configure authMiddlewareOptions
const EXPIRE_TIME = 1000 * 60 * 50 //50 mins, the CT token will expire after 60 mins.
export const validate = (gen: () => Client) => {
    const object = {
        t: new Date().getTime(),
        client: gen(),
    }
    const checkTokenValidate = () => {
        const now = new Date().getTime()
        if (now - object.t >= EXPIRE_TIME) {
            object.client = gen()
            object.t = now
        }
        return object.client
    }

    return {
        execute: (request: ClientRequest) => checkTokenValidate().execute(request),
        process: (request: ClientRequest, fn: ProcessFn, processOpt: ProcessOptions) =>
            checkTokenValidate().process(request, fn, processOpt),
    }
}

export const genClient = (
    host: string = process.env.NEXT_PUBLIC_CTP_ENDPOINT || "",
    credentials?: {
        clientId: string
        clientSecret: string
    }
) => {
    return validate(() =>
        new ClientBuilder()
            .withProjectKey(projectKey) // .withProjectKey() is not required if the projectKey is included in authMiddlewareOptions
            .withClientCredentialsFlow({
                host,
                projectKey,
                credentials: credentials || {
                    clientId: process.env.NEXT_PUBLIC_CTP_CLIENT_ID || "",
                    clientSecret: process.env.NEXT_PUBLIC_CTP_CLIENT_SECRET || "",
                },
                scopes,
            })
            .withHttpMiddleware({
                host,
            })
            // .withLoggerMiddleware() // Include middleware for logging
            .build()
    )
}

export const client = genClient()
